(function () {
  'use strict';

  var routes = {},
    routingService;

  angular
    .module('app')

    /* @ngInject */
    .config(["$routeProvider", "$locationProvider", "$httpProvider", "Routes", "DefaultLocalization", function ($routeProvider, $locationProvider, $httpProvider, Routes, DefaultLocalization) {
      $httpProvider.useApplyAsync(true);
      $httpProvider.defaults.headers.common['X-Requested-With'] = 'userHttpRequest';
      $httpProvider.interceptors.push('httpRequestInterceptor');

      var when = function (route, config) {
        if (route) {
          var ngRoute = '/' + route[DefaultLocalization].URL.replace(/\:(\S+?)\}/g, '}').replace(/\{(\S+?)\}/g, ':$1');
          routes[route.Name] = { url: route[DefaultLocalization].URL, route: ngRoute };
        }
        // désactivation du routing pour Google
        if (window.isBot || window.isCache || !config) return;
        $routeProvider.when(ngRoute, config);
      };

      _.each(Routes, function (route) {
        if (route.Controller.indexOf('Account') === 0) { // Compte
          var component = _.kebabCase(route.Name);
          var resolve = {
            /* @ngInject */
            authorize: ["authService", function (authService) {
              return authService.authorize();
            }],
            /* @ngInject */
            css: ["LoadService", function (LoadService) {
              return LoadService.load('css', 'cssAccount', $(document.body).data('css-account'));
            }],
            /* @ngInject */
            module: ["LoadService", function (LoadService) {
              return LoadService.load('js', 'app.account', $(document.body).data('js-account'));
            }]
          };
          var bindings = '';
          if (route.Name === 'AccountReturns') {
            /* @ngInject */
            resolve.result = function (AccountService) {
              return AccountService.getReturnFolders();
            };
            resolve.result.$inject = ["AccountService"];
            bindings = ' result="$resolve.result"';
          } else if (route.Name === 'AccountUpdate') {
            /* @ngInject */
            resolve.result = function (AccountService) {
              return AccountService.getShippingAddresses();
            };
            resolve.result.$inject = ["AccountService"];
            bindings = ' result="$resolve.result"';
          }
          when(route, {
            template: '<' + component + bindings + ' device="device"></' + component + '>',
            resolve: resolve,
            name: route.Controller,
            ngRoute: true
          });
        } else if (route.Controller.indexOf('Cart') !== -1) { // Panier
          var resolveObject = {
            /* @ngInject */
            css: ["LoadService", function (LoadService) {
              return LoadService.load('css', 'cssCart', $(document.body).data('css-cart'));
            }],
            /* @ngInject */
            module: ["LoadService", function (LoadService) {
              return LoadService.load('js', 'app.cart', $(document.body).data('js-cart'));
            }]
          };

          if (route.Name === 'QuickOrder') {
            when(route, {
              templateUrl: '/Template/Cart/QuickOrderForm',
              name: route.Name,
              cart: true,
              resolve: resolveObject,
              ngRoute: true
            });
          } else if (route.Name === 'Cart' || route.Name === 'CartRecognition') {
            when(route, {
              templateUrl: '/Template/Cart/Display',
              name: route.Name,
              cart: true,
              resolve: resolveObject,
              ngRoute: true
            });
          } else {
            when(route, {
              templateUrl: function () {
                return '/Template/Cart/' + route.Name.split('Cart')[1];
              },
              name: route.Name,
              cart: true,
              resolve: resolveObject,
              authorize: true,
              ngRoute: true
            });
          }
        } else if (route.Name === 'CartQuotationPaymentList') {
          var resolveQuotation = {
            /* @ngInject */
            css: ["LoadService", function (LoadService) {
              return LoadService.load('css', 'cssCart', $(document.body).data('css-cart'));
            }],
            /* @ngInject */
            module: ["LoadService", function (LoadService) {
              return LoadService.load('js', 'app.cart', $(document.body).data('js-cart'));
            }]
          };

          when(route, {
            templateUrl: function () {
              return routingService.getLocation();
            },
            name: route.Name,
            cart: true,
            resolve: resolveQuotation,
            ngRoute: true
          });
        } else {
          when(route, {
            templateUrl: function () {
              return routingService.getLocation();
            },
            name: route.Name
          });
        }
      });

      if (window.isBot || window.isCache) {
        $locationProvider.html5Mode({
          enabled: true,
          requireBase: true,
          rewriteLinks: false
        });
        // désactivation du routing pour Google
        return;
      }

      $routeProvider.otherwise({
        templateUrl: function () {
          return routingService.getLocation();
        }
      });

      $routeProvider.when('/404', {
        templateUrl: '/Template/Error/Error',
        name: '404'
      });

      $locationProvider.html5Mode({
        enabled: true
      });

    }])

    /* @ngInject */
    .factory('RoutesService', function () {
      var routesService = {};
      return {
        set: function (value) {
          if (!_.isEmpty(routesService)) return;
          routesService = value;
          return routesService;
        },
        get: function () {
          return routesService;
        },
        getUrlByName: function (name) {
          return routesService[name] && routesService[name].url ? routesService[name].url : '';
        }
      };
    })

    /* @ngInject */
    .factory('RoutingService', ["$timeout", "$location", "$window", function ($timeout, $location, $window) {
      var _this = this;
      this.routing = {};
      this.scrollCache = {};

      this.set = function (value) {
        _this.routing = value;
      };
      this.get = function () {
        return _this.routing;
      };
      this.getLocation = function () {
        return $location.path() + '?t';
      };
      this.getRoute = function (url) {
        return '/' + url.replace(/\:(\S+?)\}/g, '}').replace(/\{(\S+?)\}/g, ':$1');
      };
      this.getPath = function (url) {
        var path = url || $window.location.pathname;
        path = path.indexOf('http') !== -1 && $window.location && $window.location.origin ? path.substr($window.location.origin.length).split('?')[0] : path;
        // Pour les articles, on récupère l'url du regroupement
        if (path.indexOf('-p-') !== -1 && path.indexOf('-p-') > path.indexOf('-c-')) {
          var arr = path.split('-p-');
          path = arr[0] + '-p-' + arr[1].split('/')[0];
        }
        return path;
      };
      this.windowScroll = function () {
        var top = _this.scrollCache[_this.getPath()] || 0;
        $('html, body').scrollTop(top);
        $timeout(function () {
          $('html, body').scrollTop(top);
        }, 400);
      };

      return {
        set: this.set,
        get: this.get,
        getLocation: this.getLocation,
        getRoute: this.getRoute,
        getPath: this.getPath,
        windowScroll: this.windowScroll,
        scrollCache: this.scrollCache
      };
    }])

    /* @ngInject */
    .service('authService', ["AppService", function (AppService) {
      this.authorize = function (isCart) {
        return AppService.getParams()
          .then(function (params) {
            if (params.IsLogged && (!isCart || (isCart && params.HasCart))) return true;
            throw new Error(isCart && !params.HasCart ? 'noCart' : '');
          });
      };
    }])

    /* @ngInject */
    .factory('httpRequestInterceptor', ["$q", "$location", "RoutingService", function ($q, $location, RoutingService) {
      return {
        'responseError': function (rejection) {
          if (rejection.status === 404) {
            RoutingService.set({
              to: undefined,
              from: undefined
            });
            $location.path('/404/');
          }
          return $q.reject(rejection);
        }
      };
    }])

    /* @ngInject */
    .run(["RoutesService", "RoutingService", function (RoutesService, RoutingService) {
      routes.Cart.step                = 1;
      routes.CartIdentification.step  = 2;
      routes.CartShipping.step        = 3;
      routes.CartPayment.step         = 4;
      routes.CartValidation.step      = 5;
      routes.CartOnePageCheckout.step = 2;
      RoutesService.set(routes);

      routingService = RoutingService;
    }]);

})();
